import find from 'lodash/find';
const Promise = require('es6-promise').Promise;
const extractPageTitleEnable = window.__EXPERIMENTS__ && window.__EXPERIMENTS__['specs.com.ExtractPageTitle'] === 'true';

/*global window*/
module.exports = {
  resizeWindow(width, height) {
    window.Wix.resizeWindow(width, height);
  },

  instanceId() {
    return window.Wix.Utils.getInstanceId();
  },

  isInView(view) {
    return window.Wix.Utils.getViewMode() === view;
  },

  getPageName() {
    return new Promise(resolve => {
      window.Wix.Settings.getSiteInfo(siteInfo => resolve(siteInfo.pageTitle));
    });
  },

  getUserSessionToken() {
    return new Promise(resolve => {
      window.Wix.Activities.getUserSessionToken(sessionToken => resolve(sessionToken));
    });
  },

  syncPageTitle(handler) {
    window.Wix.Settings.getSiteInfo(siteInfo => {
      const pipeIndex = siteInfo.pageTitle.indexOf(' | ');
      let title;

      if (pipeIndex === -1) {
        title = siteInfo.pageTitle;
      } else if (extractPageTitleEnable) {
        title = siteInfo.pageTitle.substr(0, pipeIndex);
      } else {
        title = siteInfo.pageTitle.substr(pipeIndex + 3);
      }

      handler(title);
    });
  },

  getInstance() {
    const instance = find(window.location.search.split('&'), str => str.indexOf('instance=') >= 0);
    return instance ? instance.split('=')[1] : '';
  },

  subscribeForNavigation(handler) {
    window.Wix.addEventListener(window.Wix.Events.PAGE_NAVIGATION, () => {
      this.syncPageTitle(handler);
    });
  },

  subscribeForMetadataChange(handler) {
    window.Wix.addEventListener(window.Wix.Events.SITE_METADATA_CHANGED, () => {
      this.syncPageTitle(handler);
    });
  },

  subscribeForSessionTokenChange(handler) {
    window.Wix.addEventListener(window.Wix.Events.SESSION_CHANGED, handler);
  },

  getSitePrimaryColor(pallet) {
    const primaryColor = pallet.filter(color => color.reference === 'color-8');
    return primaryColor.length ? primaryColor[0].value : null;
  },

  getSiteColors() {
    return new Promise(resolve => {
      window.Wix.Styles.getSiteColors(colors => resolve(colors));
    });
  },

  subscribeForStyleChange(handler) {
    const self = this;
    window.Wix.addEventListener(window.Wix.Events.STYLE_PARAMS_CHANGE, () => this.getSiteColors().then(colors => handler(self.getSitePrimaryColor(colors))));
  },

  syncSitePrimaryColor(handler) {
    const self = this;
    this.getSiteColors().then(colors => {
      handler(self.getSitePrimaryColor(colors));
    });
  },

  onSettingsUpdate(settingsActions) {
    window.Wix.addEventListener(window.Wix.Events.SETTINGS_UPDATED, ({key, value}) => {
      if (settingsActions[key]) {
        settingsActions[key](value);
      } else {
        console.warn(`Unhandled settings event: ${arguments}`);
      }
    });
  },

  updateQab({visible, notifications}) {
    window.Wix.Mobile.setMobileActionBarButton({visible, notifications: !!notifications});
  },

  registerQab(callback) {
    window.Wix.addEventListener(window.Wix.Events.QUICK_ACTION_TRIGGERED, callback);
  },

  showMobileComponent() {
    window.Wix.Mobile.showFullscreen();
  },

  hideMobileComponent() {
    window.Wix.Mobile.hideFullscreen();
  }
};



// WEBPACK FOOTER //
// ./chat-app/utils/wix.js